import React, { PureComponent } from "react";
import RegisterForm from "./components/RegisterForm";
import RegistrationSuccess from "./components/RegistrationSuccess";
import { Link } from "react-router-dom";
import KBELogo from "../img/kbe-Logo-66454.png";
import AppConfig from "../../../config/appconfig.json";

export default class Register extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isRegistrationSucess: false,
      isLoading: false,
      isLoginError: false,
      loginErrorMsg: ""
    };
    this.handleSubmitRegister = this.handleSubmitRegister.bind(this);
  }

  handleSubmitRegister(data) {
    this.setState({ isLoading: true, isLoginError: false });
    const requestJson = {
      Username: data.username,
      Email: data.email,
      Password: data.password
    };
    const request = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestJson)
    };
    // Call Back-End Services
    fetch(`${AppConfig.BACK_END_URL}/APIClient/CreateCustomer`, request)
      .then(response => {
        // console.log(response);
        if (response.ok === false) {
          this.setState({ isLoginError: true });
        }
        return response.json();
      })
      .then(json => {
        // console.log(json);
        // const sid = json.Sid;
        if (this.state.isLoginError) {
          const respObj = JSON.parse(json);
          this.setState({ isLoading: false, loginErrorMsg: respObj.Message });
        } else {
          this.setState({ isRegistrationSucess: true, isLoading: false });
          // console.log(json);
        }
      })
      .catch((status, err) => {
        // console.log(status);
        // console.log(err);
        this.setState({
          isLoading: false,
          isLoginError: true,
          loginErrorMsg: "Something went wrong during registration"
        });
      });
  }

  render() {
    return (
      <div className="account">
        <div className="account__wrapper">
          <div className="account__card">
            <div className="account__head">
              <img src={KBELogo} alt="logo" />
            </div>
            {this.state.isRegistrationSucess ? (
              <RegistrationSuccess />
            ) : (
              <RegisterForm
                onSubmit={this.handleSubmitRegister}
                isLoading={this.state.isLoading}
                isLoginError={this.state.isLoginError}
                loginErrorMsg={this.state.loginErrorMsg}
              />
            )}
            <div className="account__have-account">
              <p>
                Already have an account? <Link to="/">Login</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/register/Register.js